<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { useVModel } from '@vueuse/core';
    import { cn } from '../utils';

    const props = defineProps<{
        class?: HTMLAttributes['class'];
        defaultValue?: string | number;
        modelValue?: string | number;
    }>();

    const emits = defineEmits<{
        'update:modelValue': [string];
    }>();

    const modelValue = useVModel(props, 'modelValue', emits, {
        passive: true,
        defaultValue: props.defaultValue,
    });
</script>

<template>
    <textarea
        v-model="modelValue"
        data-slot="textarea"
        :class="
            cn(
                'border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 flex field-sizing-content min-h-16 w-full rounded-md border bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
                props.class,
            )
        "
    />
</template>
